export default __webpack_public_path__ + "4801f0ab6112b9b59cba5329c764cae7.webp";